import React from "react";
import { Helmet } from "react-helmet-async";
import { Email } from "react-obfuscate-email";

const Contact = () => {
  return (
    <div className='mt-14 bg-white flex items-center justify-center mb-10'>
      <Helmet>
        <title>Contact Us | tastebud.ee</title>
        <meta name='description' content='Need help setting up your allergen menus or have a question about tastebud.ee? Email hello@tastebud.ee and we will get back to you within 24 hours.' />
        <link rel='canonical' href='https://tastebud.ee/contact' />
      </Helmet>
      <div className='px-6 max-w-screen-sm'>
        <h1 className='text-xl font-bold mb-4'>Contact</h1>
        <p className='mb-4'>
          Whether you need help in getting started or are having problems logging in, please drop us an email using <Email email='hello@tastebud.ee'>hello at tastebud.ee</Email> and we’ll get back to
          you within 24 hours.
        </p>
      </div>
    </div>
  );
};

export default Contact;
